module.exports = __webpack_public_path__ + "static/media/Contrato.51ec1b98.svg";